import {useConnectWS, useScreens} from 'api/modules/streamer';
import Button from 'components/Form/Button/Button';
import Input from 'components/Form/Input/Input';
import ObsScreenAndUsers from 'components/ObsManagement/ObsScreenAndUsers/ObsScreenAndUsers';
import ObsView from 'components/ObsManagement/ObsView/ObsView';
import React, {useCallback, useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {ObsRoom} from 'types/entities/Obs';
import {makeid} from 'utils/common';
import {GlobalMessageNotificationHandler} from 'utils/errorHandler';

type ObsRoomCreationForm = {
  link: string;
  password: string;
};

const AdminPanel: React.FC = () => {
  const LinkToken = 'savedLink';
  const PasswordToken = 'savedPassword';

  const wsConnection = useConnectWS('/ws');
  const allScreens = useScreens(undefined, {enabled: wsConnection.isSuccess});

  const [obsRoom, setObsRoom] = useState<ObsRoom>();
  const [obsLink, setObsLink] = useState<string | undefined>();
  const [obsInviteLink, setObsInvteLink] = useState<string | undefined>();

  const [savedData] = useState<ObsRoom>({
    roomName: localStorage.getItem(LinkToken) || '',
    password: localStorage.getItem(PasswordToken) || '',
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: {errors},
  } = useForm<ObsRoomCreationForm>();

  useEffect(() => {
    if (savedData.roomName !== '') setValue('link', savedData.roomName);
    if (savedData.password !== '') setValue('password', savedData.password);
  }, [savedData, setValue]);

  const onSubmit = (data: ObsRoomCreationForm) => {
    localStorage.setItem(LinkToken, data.link);
    localStorage.setItem(PasswordToken, data.password);
    setObsRoom({roomName: data.link, password: data.password});
    setObsLink(
      `https://vdo.ninja/?director=${data.link}&codirector=D39nckm5iafPE'
      &password=${data.password}&cleandirector&group=1,2,3,4,5,6&showdirector&l=DIRECTOR&api=AuQipXmk8pamG2GK0ggH`,
    );
    setObsInvteLink(
      `https://vdo.ninja/?room=${data.link}&password=${data.password}&l&st`,
    );
  };

  const OnRandom = () => {
    setValue('link', makeid(10));
    setValue('password', makeid(10));
  };

  const copyLinkToClipboard = useCallback(() => {
    if (obsInviteLink) {
      navigator.clipboard.writeText(obsInviteLink);
      GlobalMessageNotificationHandler('Copied!');
    }
  }, [obsInviteLink]);

  if (!obsLink || !obsInviteLink || !obsRoom) {
    return (
      <form onSubmit={handleSubmit(onSubmit)} className="px-3 w-full">
        <Input<ObsRoomCreationForm>
          label="Room name"
          registration={{register, errors}}
          name="link"
          options={{
            minLength: {
              value: 1,
              message: 'Минимум 1 знак',
            },
          }}
        />
        <Input<ObsRoomCreationForm>
          label="Password"
          registration={{register, errors}}
          name="password"
          options={{
            minLength: {
              value: 1,
              message: 'Минимум 1 знак',
            },
          }}
        />
        <Button type="submit">Submit</Button>
        <Button onClick={OnRandom} className="ml-2">
          Random
        </Button>
      </form>
    );
  }

  return (
    <div>
      <ObsView title="test" link={obsLink} />
      <div className="mt-2 mb-4 w-full">
        <Button onClick={() => copyLinkToClipboard()} className="w-full">
          Invitation link
        </Button>
      </div>

      {allScreens.isSuccess &&
        allScreens.data
          .sort((a, b) =>
            a.ScreenId &&
            b.ScreenId &&
            parseInt(a.ScreenId.substr(a.ScreenId.length - 1), 10) >
              parseInt(b.ScreenId.substr(b.ScreenId.length - 1), 10)
              ? 1
              : -1,
          )
          .map((element, index) => (
            <ObsScreenAndUsers
              screen={element}
              room={obsRoom}
              isFirst={index === 0}
              key={index}
            />
          ))}
    </div>
  );
};

export default AdminPanel;
